import React from 'react';
/**
 * Platform 设备  平台 相关接口
 * @Author gufuyan
 * @Date 2018-08-30
 */
class PlatformFn {
    //函数参数默认值
    constructor() {
        //判断PC和移动  true 就是pc   false 移动
        this.equipment = (navigator.userAgent.toLowerCase().indexOf('windows nt') != -1 ||
        navigator.userAgent.toLowerCase().indexOf('macintosh') != -1) ? "PC" : "APP";
    }

    //判断是否是微信浏览器
    is_weixn = ()=> {
        var ua = navigator.userAgent.toLowerCase();
        if (ua.match(/MicroMessenger/i) == "micromessenger") {
            return true;
        } else {
            return false;
        }
    }
}

let _Platform = new PlatformFn();

export {_Platform}






